import EmptyCartImage from '@assets/icons/empty-cart-image.svg';
import i18n from '@/utils/i18n';
import React, { useMemo } from 'react';
import {
  AddPartitionItemsListRowContent,
  VariantPackItemMap,
} from './add-partition-items-list-row-content';
import { createStyles } from '@/contexts/theme-context';
import { EmptyStateMinimal } from '@/components/empty-state-minimal';
import { ItemListOption } from '@/contexts/item-context-types';
import { Partition } from '@/hooks/use-edit-order-guide-reducer';
import { RecyclerList } from '@/components/recycler-list';
import { StyleProp, ViewStyle } from 'react-native';

interface Props {
  contentContainerStyle?: StyleProp<ViewStyle>;
  items: ItemListOption[] | null;
  selectedPartition: Partition;
}

export const AddPartitionItemsList: React.FC<Props> = ({
  contentContainerStyle,
  items,
  selectedPartition,
}) => {
  const [styles] = useStyles();

  const variantPackItemMap = useMemo(() => {
    return selectedPartition.items.reduce<VariantPackItemMap>((result, i) => {
      result[i.itemListOption.metadata!.variantPackUUID] = i.itemUUID;
      return result;
    }, {});
  }, [selectedPartition]);

  const sections = useMemo(() => [{ data: items || [], key: null }], [items]);

  return items?.length === 0 ? (
    <EmptyStateMinimal
      containerStyle={styles.emptyStateContainer}
      ImageComponent={EmptyCartImage}
      text={i18n.t('no_search_results')}
    />
  ) : (
    <RecyclerList
      contentContainerStyle={contentContainerStyle}
      contentInsetAdjustmentBehavior="automatic"
      estimatedItemSize={120}
      extraData={{ variantPackItemMap }}
      listItemProps={{
        listItemStyle: styles.listItem,
        renderMainContent: (option) => (
          <AddPartitionItemsListRowContent
            option={option}
            partition={selectedPartition}
            variantPackItemMap={variantPackItemMap}
          />
        ),
      }}
      listItemSeparatorProps={{ style: styles.listItemSeparator }}
      sections={sections}
    />
  );
};

const useStyles = createStyles((theme) => ({
  emptyStateContainer: {
    backgroundColor: theme.colors.transparent,
  },
  listItem: {
    flex: 1,
    paddingHorizontal: 8,
    paddingVertical: 0,
  },
  listItemSeparator: {
    marginHorizontal: 8,
  },
}));
